<template>
  <div id="tab1" class="tab active">
    <!--    <Popup v-if="selectedImage" :image="selectedImage"></Popup>-->
    <isotope
      :list="list"
      id="root_isotope"
      class="isoDefault"
      :options="option"
    >
      <div
        v-for="(item, index) in list"
        :key="index"
        :class="item.extra"
        :style="{ background: item.color }"
      >
        <a class="ui-folio" @click="showModal = true">
          <!-- <span :class="'inner ' + item.show" :style="{'background': item.color}">
                                <h1 :style="{'color': item.textcolor}">{{ item.title }}</h1>
                                <p :style="{'color': item.textcolor}">{{ item.desc }}</p>
                              </span> -->
          <img class="ui-img" :src="item.image" />
        </a>
      </div>
    </isotope>
  </div>
</template>

<script>
import isotope from "vueisotope";

export default {
  components: { isotope },

  data() {
    return {
      showModal: false,
      selectedImage: "",
      list: [
        {
          image: "/img/gallery/ui/Runway.png",
          title: "Runway",
          desc: "UI banner design concept for a start up incubator brand.",
          color: "#FDFAF7",
          show: "innershow",
          textcolor: "#000 !important",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/bsc.jpg",
          title: "Battle Station",
          desc: "",
          color: "#171824",
          show: "innershow",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/Max.jpg",
          original: "/img/gallery/ui/Max.jpg",
          title: "Max Sqaure",
          desc: "Max square is the most profound real estate brand. I designed a simple yet bewitching landing page for them. ",
          color: "rgb(245 225 205)",
          textcolor: "#000 !important",
          show: "innershow",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/Healing-gardens.jpg",
          title: "Healing Gardens",
          desc: "",
          color: "rgb(184 216 213)",
          show: "innershow",
          textcolor: "#000 !important",
          extra: "item-2x",
        },

        {
          image: "/img/gallery/ui/zsites-full.jpg",
          title: "Zsites",
          desc: "Zsites was the inhouse project of Cobold Digital that builds websites in 7 days. I did the complete UI, Landing page design & branding for them.",
          color: "#C92C5F",
          show: "innershow",
          extra: "item-2x",
        },

        {
          image: "/img/gallery/ui/vj.jpg",
          title: "Vasundhra",
          desc: "Vasundhra jewellers is a client from Cobold Digital. I designed an appealing & beautiful website with great user experience for the brand.",
          color: "#2A3546",
          show: "innershow",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/dhanam.jpg",
          title: "Dhanam",
          desc: "Dhanam was an interesting startup, I did user journey, app module ideation, & app design for the brand.",
          color: "#F7CD9C",
          textcolor: "#000 !important",
          show: "innershow",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/Concept.jpg",
          title: "Concepts",
          desc: "",
          color: "#E2E5EE",
          textcolor: "#000!important",
          show: "innershow",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/ecoplore.jpg",
          title: "Ecoplore",
          desc: "Ecoplore is a client from Cobold Digital. I did the UI/UX design for the website, & also the design for the backend booking engine",
          color: "#4B6C3D",
          show: "innershow",
          extra: "item-2x",
        },

        {
          image: "/img/gallery/ui/edcast.jpg",
          title: "Edcast",
          desc: "",
          color: "#9BC4CF",
          show: "innershow",
          textcolor: "#000 !important",
          extra: "item-2x",
        },

        {
          image: "/img/gallery/ui/Swastik.jpg",
          title: "Swastik",
          desc: "",
          color: "#65A5E3",
          textcolor: "#fff!important",
          show: "innershow",
          extra: "item-2x",
        },
        {
          image: "/img/gallery/ui/zsites.jpg",
          title: "Zsites - Landing Page",
          desc: "",
          color: "#C92C5F",
          show: "innershow",
          extra: "item-2x",
        },

        {
          image: "/img/gallery/ui/Bound.png",
          original: "/img/gallery/ui/Bound.png",
          title: "Bound",
          desc: "",
          color: "#FAEB83",
          textcolor: "#000 !important",
          show: "innershow",
          extra: "item-2x",
        },
      ],
      selected: null,
      option: {
        getSortData: {
          id: "id",
        },
        sortBy: "id",
      },
    };
  },
};
</script>
